<template>
  <div class="sideItem" v-if="!item.hidden">
    <template
      v-if="hasOnlyChild(item.children, item) && (!childItem.children || childItem.noChild)"
    >
      <page-link v-if="childItem.meta" :to="resolvePath(childItem.path)">
        <el-menu-item :index="resolvePath(childItem.path)">
          <item :icon="item.meta.icon" :title="item.meta.title" />
        </el-menu-item>
      </page-link>
    </template>
    <el-submenu v-else :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :basePath="resolvePath(child.path)"
      ></sidebar-item>
    </el-submenu>
  </div>
</template>

<script>
import PageLink from "./Link";
import Item from "./Item";
import { isAbsolutePath } from "@/utils/validate";
import path from "path";

export default {
  name: "SidebarItem",
  props: {
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      childItem: null
    };
  },
  created() {
    //console.log(this.item);
    // console.log(this.basePath);
  },
  methods: {
    hasOnlyChild(children = [], item) {
      // debugger
      let newChildren =
        children != null
          ? children.filter(obj => {
              // console.log(obj)
              if (obj.hidden) {
                return false;
              } else {
                return true;
              }
            })
          : [];
      //console.log(newChildren)
      if (newChildren.length === 1 && !item.meta) {
        this.childItem = newChildren[0];
        return true;
      }
      if (newChildren.length === 0) {
        this.childItem = { ...item, path: "", noChild: true };
        return true;
      }
      return false;
    },
    resolvePath(router) {
      if (isAbsolutePath(router)) {
        return router;
      }
      if (isAbsolutePath(this.basePath)) {
        return this.basePath;
      }
      return path.join(this.basePath, router);
    }
  },
  components: {
    PageLink,
    Item
  }
};
</script>
<style scoped>
.sideItem /deep/ .el-submenu__title {
  font-size: 15px;
  color: #333;
}

.sideItem /deep/ .el-menu-item {
  font-size: 15px;
  color: #333;
}
.sideItem /deep/ .el-menu-item.is-active {
  background: #d6e2fe !important;
  color: #1f74ff !important;
}
.sideItem /deep/ .el-submenu__title i {
}
</style>



// WEBPACK FOOTER //
// src/layout/sideBar/SideBarItem.vue